import { Injectable } from '@angular/core';
import {environment} from '../../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {IdNome} from '../model/id-nome.model';

@Injectable({
  providedIn: 'root'
})
export class ColigadaService {
  urlBase = `${environment.urlBase}/coligada`;

  constructor(private  http: HttpClient) { }

  buscarColigadas(): Observable<IdNome[]> {
    return this.http.get<IdNome[]>(this.urlBase);
  }
}
